import { observer } from "mobx-react"
import {
  DocumentTemplate,
  Header,
  Page,
  PureLogo,
  useStore,
} from "@features/common"
import { PrivacyLogo } from "@features/privacy"
import { serverSidePagePrepare } from "@lib/hooks"
import { RouterLink } from "@lib/routing"
import { scrollToTop } from "@lib/scroll"
import { IconHamburger } from "@lib/icons"
import { RichContentView } from "@ui"

export const getServerSideProps = serverSidePagePrepare({
  callback: async ({ Models }) => {
    await Models.GDPRModel.getGDPRPage()
  },
})

const GDPRPage = observer(function GDPRPage() {
  const {
    GlobalModel: { openMenu },
    GDPRModel: { title, content, getTemplate },
  } = useStore()

  const seoH1 = getTemplate("seoH1")

  return (
    <Page
      meta={{
        title: getTemplate("metaTitle") || title,
        metaTitle: getTemplate("metaTitle") || title,
        description: getTemplate("metaDescription"),
      }}
      header={
        <Header
          theme="dark"
          logo={
            <RouterLink
              uri="/gdpr"
              onClick={() => scrollToTop()}
              data-test-id="header__pure_logo"
              aria-label="root"
              className="mt-4 mb-3 tablet-m:mt-[20px] tablet-m:mb-[18px]"
            >
              <div className="shrink-0 flex items-stretch h-4 tablet-m:h-7">
                <PureLogo className="shrink-0 block h-full w-auto tablet:h-full text-white pr-2 tablet-m:pr-4" />
                <PrivacyLogo />
              </div>
            </RouterLink>
          }
          languageSwitcher={null}
          navigationOpener={
            <button
              onClick={openMenu}
              data-test-id="header__menu_button"
              aria-label="menu"
            >
              <IconHamburger className="w-8 h-8 text-white" />
            </button>
          }
        />
      }
      seoH1={seoH1}
    >
      <div className="container pt-3 pb-15 laptop:pt-8 laptop:pb-20">
        <DocumentTemplate>
          <section className="space-y-10" id="scrollContainerElement">
            <div className="container p-0 font-serif">
              <h2 className="uppercase text-xl break-words tablet-s:text-5xl">
                {title}
              </h2>
            </div>
            <RichContentView src={content} />
          </section>
        </DocumentTemplate>
      </div>
    </Page>
  )
})

export default GDPRPage
